import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
import { useParams, withRouter } from 'react-router';
import FieldType from 'app/admin/dataset/dto/FieldType';
import CloneMeasurementButton from '../component/CloneMeasurementButton';
import EditFormComponentMassSomethingField from '../../common/component/EditFormComponentMassSomethingField';
import ShowChartButton from '../component/ShowChartButton';
import CreateDatasetButton from '../component/CreateDatasetButton';
import ExportMeasurementButton from '../component/ExportMeasurementButton';
import MeasurementEditService from '../service/MeasurementEditService';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';

const config = data => {
	return {
		key: 'measurementEditForm',
		topic: 'measurement',
		service: MeasurementEditService,
		tabList: initData => {
			return [{ key: 'basic' }, { key: 'fields' }];
		},
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				{
					key: 'userGroup',
					component: EditFormSelectField,
					// multiple: true,
					items: () => UserGroupService.getListSelection()
				},
				{
					key: 'table_name',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'description',
					component: EditFormTextField,
					multiline: true
				},
				{
					key: 'fields',
					tab: 'fields',
					component: EditFormGridComponent,
					defaultValue: {
						id: null,
						name: null,
						type: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'type',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: Object.keys(FieldType).map(key => {
								return { label: FieldType[key], value: key };
							})
						},
						{
							key: 'category',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: [
								{ label: 'Input', value: 'Input' },
								{ label: 'Output', value: 'Output' }
							]
						},
						{
							key: 'components',
							component: EditFormComponentMassSomethingField,
							dependsOn: 'type',
							visibleIf: type => type === 'Dict'
						},
						{
							key: 'uom',
							component: EditFormTextField
						}
					]
				}
			];

			return fields;
		}
	};
};

function MeasurementEditForm() {
	const { id } = useParams();
	const myConfig = config({ id });

	const [dto, setDto] = useState(null);

	return (
		<EditFormPage
			config={myConfig}
			beforeSaveContent={
				<>
					<CloneMeasurementButton form item={dto} />
					<CreateDatasetButton form item={dto} />
					<ExportMeasurementButton item={dto} />
					<ShowChartButton form item={dto} />
				</>
			}
			onWatch={(d) => setDto(d)}
		/>
	);
}

export default withRouter(MeasurementEditForm);
